@if (isPaid$ | async) {
  <div class="mcp-announce">
    <p class="mcp-subtitle">You have 100 calls/month included in your plan — claim your MCP bundle to start using them.</p>
    <div class="mcp-actions">
      <a [href]="mcpLink$ | async" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()"
        class="fs-standard-btn mcp-btn-accent">
        Claim bundle &rarr;
      </a>
      <a href="https://learn.flowstudio.app/mcp-getting-started" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()"
        class="fs-standard-btn">
        View Docs
      </a>
    </div>
  </div>
} @else {
  <div class="mcp-announce">
    <p class="mcp-subtitle">Try FlowStudio MCP to enable Agents to manage your Power Platform.</p>
    <ul>
      <li>Build flows</li>
      <li>Deploy flows</li>
      <li>Debug failures</li>
      <li>Monitor runs</li>
    </ul>
    <div class="mcp-actions">
      <a href="https://mcp.flowstudio.app" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()"
        class="fs-standard-btn mcp-btn-accent">
        Get started &rarr;
      </a>
      <a href="https://learn.flowstudio.app/mcp-getting-started" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()"
        class="fs-standard-btn">
        View Docs
      </a>
    </div>
  </div>
}

